import { cn } from '@rewardops/ui'
import { invertHex, type Section } from '@rewardops/utils'

import AdButton from './adButton'
import ContentfulImage from './contentfulImage'

type Props = {
  content: Section
}

function FullWidthPane(props: Props) {
  const { content } = props
  const { linkText, productUrl, backgroundColor = '000000' } = content
  const textColor = invertHex(backgroundColor)

  return (
    <div
      className="overflow-y-hiddenp-10 col-span-2 flex flex-col pb-0"
      style={{
        backgroundColor: `#${backgroundColor || '000000'}`,
        color: textColor,
      }}
    >
      <div className="m-10 text-center">
        <div className="text-5xl font-semibold">{content.headingText}</div>
        <div className="mt-3 text-2xl font-normal">{content.content}</div>
        {linkText && productUrl ? (
          <AdButton
            id={content.id}
            href={productUrl}
            aria-label={`${linkText}: ${content.headingText}`}
          >
            {linkText}
          </AdButton>
        ) : undefined}
      </div>
      <ContentfulImage
        content={content.contentImages?.[0]?.image}
        label={content.headingText ?? 'Ad Image'}
        className={cn('h-auto w-auto')}
        height="auto"
        width="auto"
        maxHeight="26rem"
        maxWidth="min(32rem, 100%)"
      />
    </div>
  )
}

export default FullWidthPane
